import { WidgetType } from 'widgets/WidgetType.ts';
import { buildHistoricalPercentageChangeStoreSlice } from 'widgets/historicalPercentageChange/store/slice.ts';
import { useConfigSlice } from 'widgets/store/configuration/configSlice';
import { SortDirection } from '@instinet-analytics/core-lib';
import { HistoricalPercentageChangeConfig } from 'widgets/historicalPercentageChange/store/HistoricalPercentageChangeConfig.ts';

export const initialHistoricalPercentageChangeWidgetConfigState: HistoricalPercentageChangeConfig =
    {
        view: 'grid',
        periodQty: 10,
        sort: [{ colId: 'date', sort: SortDirection.DESCENDING }],
        visibleColumns: ['date', 'close', 'percentChange', 'volume'],
        columnWidths: { date: 90, close: 85, volume: 85, percentChange: 90 },
        hidePrice: false,
        hidePriceLegend: false,
        hideVolume: false,
        hideVolumeLegend: false,
        hideAverageVolume: false,
    };

const { configSlice, reducer } = buildHistoricalPercentageChangeStoreSlice(
    WidgetType.HistoricalPercentageChangeWidget,
    initialHistoricalPercentageChangeWidgetConfigState
);

const useHistoricalPercentageChangeWidgetConfigSlice = () => {
    const { config, dispatchConfigChanged } = useConfigSlice(configSlice);

    return {
        config: config ?? initialHistoricalPercentageChangeWidgetConfigState,
        dispatchConfigChanged,
    };
};

export { reducer, useHistoricalPercentageChangeWidgetConfigSlice };
